import React, { useState } from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { HiChevronDown } from 'react-icons/hi2';

import {
  Section,
  Container,
  SectionHeader,
  Eyebrow,
  Title,
  Description,
  ContentGrid,
  FaqList,
  FaqItem,
  FaqButton,
  QuestionGroup,
  QuestionNumber,
  Question,
  ChevronIcon,
  AnswerWrapper,
  AnswerInner,
  Answer,
  ContactCard,
  // ContactEyebrow,
  ContactTitle,
  ContactDescription,
  ContactList,
  ContactListItem,
  ContactCheck,
  ContactButton,
  ButtonIcon,
} from './FAQ.styles';

const faqItems = [
  {
    question: 'Can I purchase products directly through the website?',
    answer:
      'No. Product inquiries and orders are handled directly by our team. This allows us to confirm product details, quantities, availability, pricing, and any ordering requirements before the purchase is finalized.',
  },
  {
    question: 'Why are prices not listed online?',
    answer:
      'Pricing may vary depending on the product, quantity, specifications, and current availability. Contact our team for up-to-date product information and a personalized quote.',
  },
  {
    question: 'Can you help me choose the right safety product?',
    answer:
      'Yes. Tell us about your workplace, industry, task, hazard, or product category, and our team can help you explore suitable options. You do not need to know the exact product before contacting us.',
  },
  {
    question: 'Do you offer products that are not shown on this page?',
    answer:
      'The website highlights common product categories and examples, but it may not represent the full range available. Contact us with the product name, type, specification, or workplace need you are looking for.',
  },
  {
    question: 'Can I place a bulk or recurring order?',
    answer:
      'Bulk and recurring product inquiries are welcome. Provide the product details, estimated quantities, and frequency required so our team can discuss available options and pricing.',
  },
  {
    question: 'How do I request a quote?',
    answer:
      'Use the product inquiry form, call our team, or email us with the products or categories you are interested in. Include quantities and any relevant specifications when possible.',
  },
  {
    question: 'How will I know whether a product is available?',
    answer:
      'Availability is confirmed after your inquiry is reviewed. Our team will provide current product details, expected availability, and any suitable alternatives when applicable.',
  },
  {
    question: 'Does purchasing a product guarantee workplace compliance?',
    answer:
      'No single product guarantees compliance. Appropriate equipment selection, workplace procedures, training, inspection, maintenance, and applicable regulatory requirements all play a role in workplace safety and compliance.',
  },
];

export default function ProductFaq() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFaq = (index) => {
    setOpenIndex((currentIndex) => (currentIndex === index ? null : index));
  };

  return (
    <Section id="product-faq">
      <Container>
        <SectionHeader>
          <Eyebrow>Frequently Asked Questions</Eyebrow>

          <Title>Product Questions, Answered</Title>

          <Description>
            Find answers to common questions about ordering, pricing,
            availability, and workplace safety products.
          </Description>
        </SectionHeader>

        <ContentGrid>
          <FaqList>
            {faqItems.map((item, index) => {
              const isOpen = openIndex === index;
              const answerId = `product-faq-answer-${index}`;
              const buttonId = `product-faq-button-${index}`;

              return (
                <FaqItem key={item.question} $open={isOpen}>
                  <FaqButton
                    id={buttonId}
                    type="button"
                    aria-expanded={isOpen}
                    aria-controls={answerId}
                    onClick={() => toggleFaq(index)}
                  >
                    <QuestionGroup>
                      <QuestionNumber aria-hidden="true">
                        {String(index + 1).padStart(2, '0')}
                      </QuestionNumber>

                      <Question>{item.question}</Question>
                    </QuestionGroup>

                    <ChevronIcon $open={isOpen} aria-hidden="true">
                      <HiChevronDown />
                    </ChevronIcon>
                  </FaqButton>

                  <AnswerWrapper
                    id={answerId}
                    role="region"
                    aria-labelledby={buttonId}
                    $open={isOpen}
                  >
                    <AnswerInner>
                      <Answer>{item.answer}</Answer>
                    </AnswerInner>
                  </AnswerWrapper>
                </FaqItem>
              );
            })}
          </FaqList>

          <ContactCard>
            {/* <ContactEyebrow>Still Have Questions?</ContactEyebrow> */}

            <ContactTitle>Speak directly with our team.</ContactTitle>

            <ContactDescription>
              Product needs can vary by workplace, quantity, task, and
              specification. Contact us for personalized assistance before
              placing an order.
            </ContactDescription>

            <ContactList>
              <ContactListItem>
                <ContactCheck aria-hidden="true">✓</ContactCheck>
                <span>Product selection guidance</span>
              </ContactListItem>

              <ContactListItem>
                <ContactCheck aria-hidden="true">✓</ContactCheck>
                <span>Availability and pricing</span>
              </ContactListItem>

              <ContactListItem>
                <ContactCheck aria-hidden="true">✓</ContactCheck>
                <span>Bulk-order inquiries</span>
              </ContactListItem>

              <ContactListItem>
                <ContactCheck aria-hidden="true">✓</ContactCheck>
                <span>Products not shown online</span>
              </ContactListItem>
            </ContactList>

            <ContactButton href="/contact-us">
              Contact Our Team
              <ButtonIcon aria-hidden="true">
                <FaArrowRight />
              </ButtonIcon>
            </ContactButton>
          </ContactCard>
        </ContentGrid>
      </Container>
    </Section>
  );
}
